<template>
  <div class="footer">
    <div class="pull-right">
      Lorem
      <strong>ipsum</strong>
      Dolor.
    </div>
    <div>
      <strong>Copyright</strong>
      {{ domain }} &copy; 2026
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterPage",
  mixins: [],
  components: {},

  props: {},

  setup() {},
  data() {
    const hostname = window.location.hostname;

    return {
      domain: hostname.replace(/^(staging\.|admin\.)+/, ""),
    };
  },
};
</script>
